import type React from "react";

import Error404 from "./pages/Error404";

function DefaultNotFoundComponent(): React.ReactElement {
  return <Error404 />;
}

export default DefaultNotFoundComponent;
